module.exports = "<app-tabUtilisateur  [utilisateurs]=\"utilisateurs\"></app-tabUtilisateur>\r\n"